/** Iter 632 — customer wizard · live-session card: brand header + Photo/Share/Till/Pay steps (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import WizardBar from "@/features/customerWizard/WizardBar";
import StoreHeader from "@/features/customerWizard/StoreHeader";
import PayChoiceCard from "@/features/customerWizard/PayChoiceCard";
import PhotoStep from "@/features/customerWizard/PhotoStep";
import ShareStep from "@/features/customerWizard/ShareStep";
import BillSection from "@/features/customerWizard/BillSection";

export default function SessionCard({ w, brandColor, textOnBrand }) {
  const {
    s, sessionId, wizardStep, recovered, payChoice, purchasedPts, photo, setPhoto,
    skipChosen, setSkipChosen, platformsQ, setProofLocal, qc, vendorRef, pointsOnly,
    extraPhotos, setExtraPhotos, makeCollage, collageBusy,
  } = w;
  return (
    <div>
      <WizardBar step={wizardStep} />
      <div className="rounded-2xl border border-slate-200 shadow-card overflow-hidden" data-testid="engage-session-panel">
      {recovered && (
        <div className="px-4 py-2.5 bg-emerald-50 border-b border-emerald-100 text-xs font-semibold text-emerald-700 text-center" data-testid="engage-session-recovered">
          Your session had expired — a fresh one was started automatically ✅
        </div>
      )}
      <StoreHeader w={w} brandColor={brandColor} textOnBrand={textOnBrand} />

      <div className="p-5 space-y-4 bg-white">
        {/* Iter 696 (694 §4) — the sale/bill renders the moment the session
            attaches, on EVERY step (Photo/Share used to hide it until the
            till step). */}
        {wizardStep < 4 && (
          <div
            className="rounded-xl bg-slate-50 border border-slate-200 px-3.5 py-2 flex items-center justify-between gap-2 text-xs"
            data-testid="engage-bill-strip"
          >
            <span className="font-bold text-slate-700 shrink-0">🧾 Sale {s.short_code || "connected"}</span>
            <span className="font-black text-slate-900 text-right">
              {s.bill_amount != null
                ? `bill $${Number(s.bill_amount).toFixed(2)}${
                    w.amounts?.charge_total != null
                      ? ` · $${Number(w.amounts.charge_total).toFixed(2)} to pay`
                      : ""
                  }`
                : "waiting for the bill"}
            </span>
          </div>
        )}
        {/* Iter-558 — step ② Photo: right after connect.
            Iter-621 — customers holding ≥50 purchased/gifted points first
            choose: review path (full discount) or points-only (flat 5%,
            no review). Earned-only customers go straight to the Photo. */}
        {wizardStep === 2 &&
          (payChoice === null &&
          purchasedPts >= 50 &&
          s.status !== "payment_only_pending_review_window" ? (
            <PayChoiceCard w={w} />
          ) : (
            <PhotoStep
              photo={photo}
              skipChosen={skipChosen}
              onPhoto={setPhoto}
              onSkip={() => setSkipChosen(true)}
            />
          ))}

        {/* Iter-558 — step ③ Share: preview, platform cards, captions,
            proof submit (POST /sessions/{id}/post). */}
        {wizardStep === 3 && (
          <ShareStep
            sessionId={sessionId}
            photo={photo}
            onRetake={() => {
              if (photo?.previewUrl) URL.revokeObjectURL(photo.previewUrl);
              setPhoto(null);
            }}
            socialLinks={s?.vendor?.social_links}
            vendor={s?.vendor}
            platforms={platformsQ.data?.platforms || null}
            onProofDone={(status) => {
              setProofLocal(status);
              qc.invalidateQueries({ queryKey: ["engage-session", sessionId] });
              qc.invalidateQueries({ queryKey: ["engage-vendor-platforms", vendorRef] });
            }}
            onSkip={() => setSkipChosen(true)}
            extraPhotos={extraPhotos}
            onAddExtra={(p) => setExtraPhotos((prev) => [...prev, p].slice(0, 3))}
            onMakeCollage={makeCollage}
            collageBusy={collageBusy}
          />
        )}

        {/* Iter-621 — Till step: the no-review points path is locked in. */}
        {wizardStep === 4 && pointsOnly && (
          <div
            className="rounded-xl bg-amber-50 border border-amber-200 px-3.5 py-2.5 text-xs font-bold text-amber-800"
            data-testid="cust-points-only-note"
          >
            ⭐ Paying with points — flat 5% off, no review needed. Your purchased points can cover
            the whole bill.
          </div>
        )}

        {/* Bill area — Iter-474: customers no longer enter their own
            bill; it arrives from the staff/till only. */}
        {wizardStep >= 4 && <BillSection w={w} />}
      </div>
    </div>
    </div>
  );
}
